import Request from '@/plugins/request'

export function getUserChangeLogs(params) {
  return Request.get('user-change-logs', { params })
}
